export default {
    namespaced: true,
    state: {
        decor: [],
        errors: {
            getDecor: ''
        }
    },
    mutations: {
        SET_DECOR(state, payload) {
            state.decor = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async getDecor({ commit }) {
            commit('SET_ERRORS', {
                key: 'getDecor',
                val: ''
            })

            const url = '/public/dict/decor'

            try {
                const resp = await this.$axios.get(url).then(res => {
                    return res.data
                })

                commit('SET_DECOR', resp)
            } catch (e) {
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getDecor',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getDecor',
                        val: 'Ошибка'
                    })
                }
            }
        }
    }
}
